// dependencies
import React from "react";
import { useIntl } from "react-intl";

// components
import CheckBox from "@cloudspire/legacy-resources/src/components/CheckBox2";
import TextInput from "@cloudspire/legacy-resources/src/components/TextInput2";

type PropsType = {
  feature;
  checked;
  distanceValue?: string;
  onChange;
};

const CheckBoxRoomFeature: React.FunctionComponent<PropsType> = (props) => {
  const { feature, checked, distanceValue, onChange } = props;

  const intl = useIntl();

  return (
    <>
      {feature.useDistance ? (
        <CheckBox
          id={`formFeatures[${feature.id}]`}
          name={`features[${feature.id}]`}
          label={feature.name}
          value={feature.id}
          checked={checked}
          onChange={onChange}
        >
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
            }}
          >
            <div>{feature.name}</div>

            <div>
              <TextInput
                style={{ maxWidth: 100 }}
                name={`featureDistances[${feature.id}]`}
                id={`formDistances[${feature.id}]`}
                value={distanceValue}
                label={intl.formatMessage({
                  defaultMessage: "km",
                })}
                disabled={!checked}
                onChange={onChange}
              />
            </div>
          </div>
        </CheckBox>
      ) : (
        <CheckBox
          id={`formFeatures[${feature.id}]`}
          name={`features[${feature.id}]`}
          label={feature.name}
          value={feature.id}
          checked={checked}
          onChange={onChange}
        />
      )}
    </>
  );
};

export default CheckBoxRoomFeature;
